import React from 'react';
import style from './MessageBlock.module.css';

function MessageBlock({children, ...props}) {
    return (
        <div className={style.main}>
            {children}
        </div>
    );
}

export default MessageBlock;